import logger from '../logger'

function get({key}) {
    if (!key) {
        logger.warn(`[firebase] storage get error, ${key}`)
        return false
    }

    let res

    try {
        res = localStorage.getItem(key)
    } catch (e) {
        logger.warn('[firebase] storage get error')
    }

    return res
}

function set({key, metrics, url}) {
    if (!key || !metrics || !url) {
        logger.warn(`[firebase] storage set error, ${key},${metrics},${url}`)
        return false
    }

    try {
        localStorage.setItem(key, JSON.stringify({metrics, url}));
    } catch (e) {
        logger.warn('[firebase] storage set error')
    }
}

function clear({key}) {
    if (!key) {
        logger.warn(`[firebase] storage remove error, ${key}`)
        return false
    }

    try {
        localStorage.removeItem(key);
    }catch (e) {
        logger.warn('[firebase] storage remove error')
    }
}

export default {
    get,
    set,
    clear,
}
